import Vue from "vue";
import Buefy, { ConfigProgrammatic } from "buefy";
import VueMask from 'v-mask';
// import * as VueGoogleMaps from 'vue2-google-maps';
import * as GmapVue from "gmap-vue";
import msalPlugin from "vue-msal-browser";
import VueTheMask from "vue-the-mask";
import Vuelidate from "vuelidate";
import "chart.js";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import auth from "./auth";
import iframe from "./iframe";
import "buefy/dist/buefy.css";
import "../public/reset.css";
import "../public/rtl.css";
import "../public/animations.css";
import "./filters/dates";
import "./interceptor";

Vue.use(auth, { store });
const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
    scopes: ['User.Read']
  },
  cache: {
    cacheLocation: "sessionStorage"
  },
  mode: "popup"
};
Vue.use(msalPlugin, msalConfig);
Vue.use(Buefy);
Vue.use(iframe);
Vue.use(VueMask);
ConfigProgrammatic.setOptions({
  defaultProgrammaticPromise: true
});
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(VueFilterDateFormat);

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyAqt5OaqSDQ0CQ1cN9-i4WErrMhanIB1K4",
    libraries: "visualization",
    zoom: 3,
  },
  installComponents: true
});

Vue.config.productionTip = false;

// Sentry.init({
//   Vue,
//   dsn: "https://aa1bb4883f4b46d28093a560708a2d0c@o208346.ingest.sentry.io/6501646",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["vms.betterway.co.il", /^\//]
//     })
//   ],
//   denyUrls: ["localhost"],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   environment: "production",
//   release: "betterway-prod@1.0.0"
// });

new Vue({
  router,
  store,
  // eslint-disable-next-line arrow-parens
  render: h => h(App)
}).$mount("#app");
